import React from 'react';
import { Box } from '@wix/design-system';
import classNames from 'classnames';
import s from './GridHeader.scss';
import { GridHeaderCell } from './GridHeaderCell';
import { ProductsGridContext } from '../../ProductsGrid';
import { useResizeObserver } from '../../../../hooks/useResizeObserver';
import { Z_INDEX } from '../../consts';
export const GridHeader = ({ children, innerRef, dataHook, className, marginTop, }) => {
    const { setMarginTop, handleGridHeaderResize } = React.useContext(ProductsGridContext);
    marginTop && setMarginTop(marginTop);
    useResizeObserver({
        ref: innerRef,
        callback: handleGridHeaderResize,
        dep: [innerRef?.current],
    });
    return (React.createElement(Box, { dataHook: dataHook, className: classNames(s.header, className), display: "contents" },
        React.createElement(Box, { className: s.headerCell, zIndex: Z_INDEX.GRID_HEADER },
            React.createElement("div", { ref: innerRef })),
        children));
};
GridHeader.Cell = GridHeaderCell;
//# sourceMappingURL=GridHeader.js.map